// Enhanced AutoSizeDropdown.js with Modal Support
document.addEventListener('DOMContentLoaded', function() {
  initUniversalDropdowns();
});

// Listen for common modal and dynamic content events
document.addEventListener('modal:open', initUniversalDropdowns);
document.addEventListener('modal:loaded', initUniversalDropdowns);
document.addEventListener('quickview:loaded', initUniversalDropdowns);
document.addEventListener('product:loaded', initUniversalDropdowns);
document.addEventListener('cart:loaded', initUniversalDropdowns);
document.addEventListener('shopify:section:load', initUniversalDropdowns);

// Generic modal detection - check after page fully loads
window.addEventListener('load', function() {
  setTimeout(initUniversalDropdowns, 500);
});

function initUniversalDropdowns() {
  setTimeout(function() {
    replaceConditionSelectsWithCustom();
    setupUniversalVariantWatcher();
  }, 100);
}

function replaceConditionSelectsWithCustom() {
  console.log('🔍 Scanning for condition dropdowns...');
  
  const selects = document.querySelectorAll('.select__select, select[name*="options"], select[name*="Condition"], select[name*="condition"]');
  
  console.log(`Found ${selects.length} total select elements`);
  
  selects.forEach((select, index) => {
    // NO VISIBILITY CHECK - process all condition selects
    
    const isConditionSelect = 
      select.name && (select.name.toLowerCase().includes('condition')) ||
      select.closest('.product-form__input--dropdown')?.querySelector('.form__label')?.textContent.toLowerCase().includes('condition') ||
      select.closest('[data-variant-type="condition"]') ||
      Array.from(select.options).some(opt => 
        opt.text.toLowerCase().includes('new') || 
        opt.text.toLowerCase().includes('used') || 
        opt.text.toLowerCase().includes('refurbished')
      );
    
    if (isConditionSelect) {
      const container = select.closest('.select') || select.parentElement;
      const existingCustom = container?.parentNode?.querySelector('.custom-select-replacement');
      
      if (!existingCustom) {
        console.log(`🔄 Creating custom dropdown ${index + 1}:`, select.name || 'unknown');
        createCustomDropdown(select);
      } else {
        console.log(`⏭️ Skipping already converted dropdown ${index + 1}`);
      }
    }
  });
}

// Enhanced MutationObserver for modals and dynamic content
function setupUniversalVariantWatcher() {
  // Listen for Shopify variant changes
  document.addEventListener('variant:change', function() {
    console.log('🔄 Shopify variant changed - recreating dropdowns');
    setTimeout(replaceConditionSelectsWithCustom, 50);
  });
  
  // Aggressive modal and content watching
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check for modal-specific classes and content
            const isModal = node.classList?.contains('modal') || 
                           node.classList?.contains('drawer') ||
                           node.classList?.contains('popup') ||
                           node.classList?.contains('quick-add') ||
                           node.classList?.contains('product-modal') ||
                           node.querySelector?.('.modal, .drawer, .popup, .quick-add, .product-modal');
            
            const hasSelects = node.querySelector?.('select') || 
                             node.querySelector?.('.select__select') ||
                             node.classList?.contains('product-form') ||
                             node.querySelector?.('.product-form');
            
            const isVariantContent = node.querySelector?.('variant-selects') ||
                                   node.classList?.contains('product-variants') ||
                                   node.querySelector?.('.product-variants');
            
            if (isModal || hasSelects || isVariantContent) {
              shouldUpdate = true;
              console.log('🔄 Modal or new variant content detected');
            }
          }
        });
      }
    });
    
    if (shouldUpdate) {
      setTimeout(replaceConditionSelectsWithCustom, 150);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function createCustomDropdown(originalSelect) {
  const selectContainer = originalSelect.closest('.select') || originalSelect.parentElement;
  const dropdownContainer = originalSelect.closest('.product-form__input--dropdown');
  
  // Remove any existing loading states
  if (dropdownContainer) {
    dropdownContainer.classList.remove('loading');
    const existingLoader = dropdownContainer.querySelector('.custom-loading');
    if (existingLoader) existingLoader.remove();
  }
  
  // Handle different container structures
  let insertionPoint = selectContainer;
  if (selectContainer.classList.contains('select')) {
    insertionPoint = selectContainer;
  } else {
    insertionPoint = originalSelect;
  }
  
  // Get all options from original select
  const options = Array.from(originalSelect.options).map(option => ({
    value: option.value,
    text: option.text,
    selected: option.selected
  }));
  
  const selectedOption = options.find(opt => opt.selected) || options[0];
  
  // Create custom dropdown container
  const customDropdown = document.createElement('div');
  customDropdown.className = 'custom-select-replacement';
  customDropdown.innerHTML = `
    <div class="custom-select-display">
      <span class="custom-select-text">${selectedOption.text}</span>
      <svg class="custom-select-arrow" width="12" height="8" viewBox="0 0 12 8">
        <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="custom-select-options">
      ${options.map(option => 
        `<div class="custom-select-option ${option.selected ? 'selected' : ''}" data-value="${option.value}">
          ${option.text}
        </div>`
      ).join('')}
    </div>
  `;
  
  // Hide original elements
  originalSelect.style.setProperty('display', 'none', 'important');
  if (selectContainer !== originalSelect) {
    selectContainer.style.setProperty('display', 'none', 'important');
  }
  
  // Insert custom dropdown
  insertionPoint.parentNode.insertBefore(customDropdown, insertionPoint.nextSibling);
  
  // Size the display to the selected option
  resizeCustomDisplay(customDropdown, selectedOption.text);
  
  // Set up event handlers
  setupCustomDropdownHandlers(customDropdown, originalSelect);
  
  console.log('✅ Custom dropdown created successfully');
}

function setupCustomDropdownHandlers(customDropdown, originalSelect) {
  const display = customDropdown.querySelector('.custom-select-display');
  const textSpan = customDropdown.querySelector('.custom-select-text');
  const optionsContainer = customDropdown.querySelector('.custom-select-options');
  const options = customDropdown.querySelectorAll('.custom-select-option');
  
  // Click display to toggle options
  display.addEventListener('click', function(e) {
    e.stopPropagation();
    
    // Close other custom dropdowns
    document.querySelectorAll('.custom-select-replacement.open').forEach(dropdown => {
      if (dropdown !== customDropdown) {
        dropdown.classList.remove('open');
      }
    });
    
    // Toggle this dropdown
    customDropdown.classList.toggle('open');
  });
  
  // Click option to select
  options.forEach(option => {
    option.addEventListener('click', function(e) {
      e.stopPropagation();
      
      const value = this.dataset.value;
      const text = this.textContent.trim();
      
      console.log(`🔄 Option clicked: "${text}"`);
      
      // Update display
      textSpan.textContent = text;
      
      // Update original select
      originalSelect.value = value;
      
      // Update selected class
      options.forEach(opt => opt.classList.remove('selected'));
      this.classList.add('selected');
      
      // Resize display to new text
      resizeCustomDisplay(customDropdown, text);
      
      // Close dropdown
      customDropdown.classList.remove('open');
      
      // Trigger change event on original select
      originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
      
      console.log(`✅ Custom dropdown selected: "${text}" → resized`);
    });
  });
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!customDropdown.contains(e.target)) {
      customDropdown.classList.remove('open');
    }
  });
}

function resizeCustomDisplay(customDropdown, selectedText) {
  const display = customDropdown.querySelector('.custom-select-display');
  
  if (!display) {
    console.error('Custom display element not found');
    return;
  }
  
  // TRIM whitespace and normalize the text
  const cleanText = selectedText.trim();
  const textLength = cleanText.length;
  
  // Calculate width: characters * average width + padding + arrow space
  let width = (textLength * 8) + 50; 
  width = Math.max(120, Math.min(width, 350)); 
  
  // Set CSS custom property
  display.style.setProperty('--custom-dropdown-width', width + 'px');
  
  console.log(`📏 Custom display resized: "${cleanText}" (${textLength} chars) → ${width}px`);
}

// Enhanced click detection for modals that might not trigger other events
document.addEventListener('click', function(e) {
  // If clicking on something that might open a modal
  if (e.target.closest('[data-bs-toggle="modal"]') || 
      e.target.closest('.quick-add') ||
      e.target.closest('[href*="quick"]') ||
      e.target.closest('.product-item') ||
      e.target.closest('.card-product')) {
    
    setTimeout(function() {
      console.log('🔄 Potential modal trigger detected - checking for dropdowns');
      replaceConditionSelectsWithCustom();
    }, 300);
  }
});